import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

/** What a caller may pass when opening the loader. */
export interface LoaderDiagData {
  loaderMessage?: string;
}

@Component({
    selector: 'app-loader-diag',
    imports: [MatProgressSpinnerModule],
    templateUrl: './loader-diag.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./loader-diag.component.scss']
})
export class LoaderDiagComponent {
  private readonly data = inject<LoaderDiagData | null>(MAT_DIALOG_DATA, { optional: true });

  /**
   * Defaulted rather than required: MatDialog supplies null when a caller opens
   * the dialog without `data`, and several already do.
   */
  readonly loaderMessage = this.data?.loaderMessage ?? 'Loading...';
}
